/* eslint-disable no-param-reassign */
import deepEqual from 'deep-equal';
import {isEqual} from 'lodash';

export const basicShouldComponentUpdate = (
  currentProps,
  currentState,
  nextProps,
  nextState,
  propKeys,
  objectPropKeys,
  arrayPropKeys,
  nestedPropKeys,
) => {
  propKeys = propKeys || [];
  objectPropKeys = objectPropKeys || [];
  arrayPropKeys = arrayPropKeys || [];
  nestedPropKeys = nestedPropKeys || [];

  for (let i = 0; i < propKeys.length; i++) {
    if (currentProps && nextProps && currentProps[propKeys[i]] !== nextProps[propKeys[i]]) return true;

    if (currentState && nextState && currentState[propKeys[i]] !== nextState[propKeys[i]]) return true;
  }

  for (let i = 0; i < objectPropKeys.length; i++) {
    if (currentProps && nextProps && !deepEqual(currentProps[objectPropKeys[i]], nextProps[objectPropKeys[i]]))
      return true;

    if (currentState && nextState && !deepEqual(currentState[objectPropKeys[i]], nextState[objectPropKeys[i]]))
      return true;
  }

  for (let i = 0; i < arrayPropKeys.length; i++) {
    if (
      currentProps &&
      nextProps &&
      !deepEqual({array: currentProps[arrayPropKeys[i]]}, {array: nextProps[arrayPropKeys[i]]})
    )
      return true;

    if (
      currentState &&
      nextState &&
      !deepEqual({array: currentState[arrayPropKeys[i]]}, {array: nextState[arrayPropKeys[i]]})
    )
      return true;
  }

  for (let i = 0; i < nestedPropKeys.length; i++) {
    if (
      currentProps &&
      nextProps &&
      !isEqual(JSON.stringify(currentProps[nestedPropKeys[i]]), JSON.stringify(nextProps[nestedPropKeys[i]]))
    )
      return true;

    if (
      currentState &&
      nextState &&
      !isEqual(JSON.stringify(currentState[nestedPropKeys[i]]), JSON.stringify(nextState[nestedPropKeys[i]]))
    )
      return true;
  }

  return false;
};

export const memoEqual = (prevProps, nextProps, propKeys, objectPropKeys, arrayPropKeys, nestedPropKeys) => {
  propKeys = propKeys || [];
  objectPropKeys = objectPropKeys || [];
  arrayPropKeys = arrayPropKeys || [];
  nestedPropKeys = nestedPropKeys || [];

  for (let i = 0; i < propKeys.length; i++) {
    if (prevProps && nextProps && prevProps[propKeys[i]] !== nextProps[propKeys[i]]) return false;
  }

  for (let i = 0; i < objectPropKeys.length; i++) {
    if (prevProps && nextProps && !deepEqual(prevProps[objectPropKeys[i]], nextProps[objectPropKeys[i]])) return false;
  }

  for (let i = 0; i < arrayPropKeys.length; i++) {
    if (
      prevProps &&
      nextProps &&
      !deepEqual({array: prevProps[arrayPropKeys[i]]}, {array: nextProps[arrayPropKeys[i]]})
    )
      return false;
  }

  for (let i = 0; i < nestedPropKeys.length; i++) {
    if (
      prevProps &&
      nextProps &&
      !isEqual(JSON.stringify(prevProps[nestedPropKeys[i]]), JSON.stringify(nextProps[nestedPropKeys[i]]))
    )
      return false;
  }

  return true;
};
